import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowAlert && _vm.isEditorOrAbove)?_c('tooltip',{attrs:{"text":_vm.textTooltip}},[_c(VIcon,{attrs:{"color":_vm.icon.color,"size":16}},[_vm._v(" "+_vm._s(_vm.icon.use)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }